var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('a',{class:_vm.buttonClass + ' px-2',staticStyle:{"width":"100% !important"},attrs:{"href":`https://api.whatsapp.com/send?phone=${_vm.phone}&text=${_vm.text}`,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.buttonlabel)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }